import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "k-badge__variant-icon row items-center justify-center"
}

import { toRef } from 'vue'

interface IProps {
  rootClass?: string | (string | Record<PropertyKey, boolean>)[] | Record<PropertyKey, boolean>
  label?: string
  labelClass?: string | (string | Record<PropertyKey, boolean>)[] | Record<PropertyKey, boolean>
  color?: string
  textColor?: string
  borderColor?: string
  icon?: string
  iconColor?: string
  iconSize?: string
  iconClass?: string
  clearable?: boolean
  variant?: string | number
  variantClass?: string | (string | Record<PropertyKey, boolean>)[] | Record<PropertyKey, boolean>
  variantBgColor?: string
  variantIcon?: string
  variantInnerIcon: boolean
  outline?: boolean
  error?: boolean
  success?: boolean
  disable?: boolean
  hoverless?: boolean
  size?: 'sm' | 'md'
}


export default /*@__PURE__*/_defineComponent({
  ...{ name: 'KBadge', inheritAttrs: false },
  __name: 'KBadge',
  props: {
    rootClass: { default: '' },
    label: { default: '' },
    labelClass: { default: '' },
    color: { default: 'teal-white-10' },
    textColor: { default: 'cool-gray-100' },
    borderColor: { default: 'space-b-20' },
    icon: { default: '' },
    iconColor: { default: 'cool-gray-60' },
    iconSize: { default: '20px' },
    iconClass: { default: '' },
    clearable: { type: Boolean, default: false },
    variant: { default: '' },
    variantClass: { default: '' },
    variantBgColor: { default: 'white' },
    variantIcon: { default: '' },
    variantInnerIcon: { type: Boolean, default: false },
    outline: { type: Boolean, default: false },
    error: { type: Boolean, default: false },
    success: { type: Boolean, default: false },
    disable: { type: Boolean, default: false },
    hoverless: { type: Boolean, default: false },
    size: { default: 'md' }
  },
  emits: ['cleared'],
  setup(__props: any) {

_useCssVars(_ctx => ({
  "be443848": (borderColor.value),
  "c987b730": (color.value),
  "v58285e22": (iconColor.value)
}))


const props = __props


const color = toRef(() => `var(--${props.color})`)
const borderColor = toRef(() => `var(--${props.borderColor})`)
const iconColor = toRef(() => `var(--${props.iconColor})`)

return (_ctx: any,_cache: any) => {
  const _component_k_icon = _resolveComponent("k-icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["k-badge", ['inline-block', { 'cursor-pointer': __props.variant }, __props.rootClass]])
  }, [
    _renderSlot(_ctx.$slots, "before"),
    _createElementVNode("div", _mergeProps({
      class: ["k-badge__main", [
        `text-${__props.textColor}`,
        `k-badge__main--${__props.size}`,
        {
          clearable: __props.clearable,
          prepend: __props.icon,
          variant: __props.variant,
          success: __props.success,
          error: __props.error,
          outline: __props.outline,
          disabled: __props.disable,
          'no-hover': __props.hoverless,
        },
      ]]
    }, _ctx.$attrs), [
      _renderSlot(_ctx.$slots, "prepend"),
      _renderSlot(_ctx.$slots, "default", {}, () => [
        (__props.icon)
          ? (_openBlock(), _createBlock(_component_k_icon, {
              key: 0,
              color: "inherit",
              name: __props.icon,
              class: _normalizeClass(['prepend-icon', __props.iconClass]),
              size: __props.iconSize
            }, null, 8, ["name", "class", "size"]))
          : _createCommentVNode("", true),
        _renderSlot(_ctx.$slots, "variant", {}, () => [
          (__props.variant)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass([
              'variant-section row justify-center inline',
              __props.variantClass,
              `bg-${__props.variantBgColor}`,
              { 'has-prepend-icon': __props.variantInnerIcon },
            ])
              }, [
                (__props.variantInnerIcon)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_1, "+"))
                  : _createCommentVNode("", true),
                _createTextVNode(" " + _toDisplayString(__props.variant), 1)
              ], 2))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("span", {
          class: _normalizeClass([__props.labelClass, { 'fs-13px fw-500': !__props.variant }])
        }, _toDisplayString(__props.label), 3),
        (__props.variantIcon)
          ? (_openBlock(), _createBlock(_component_k_icon, {
              key: 1,
              color: "inherit",
              name: __props.variantIcon,
              class: "variant-icon",
              size: __props.iconSize
            }, null, 8, ["name", "size"]))
          : _createCommentVNode("", true)
      ]),
      _renderSlot(_ctx.$slots, "append", {}, () => [
        (__props.clearable)
          ? (_openBlock(), _createBlock(_component_k_icon, {
              key: 0,
              class: "clear-icon cursor-pointer",
              name: "remove",
              size: "20px",
              color: "inherit",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('cleared')))
            }))
          : _createCommentVNode("", true)
      ])
    ], 16),
    _renderSlot(_ctx.$slots, "after")
  ], 2))
}
}

})